import useSWR from 'swr';
import useCustomerId from './useCustomerId';

interface UseProductsByCustomerParams {
  allowRequest?: boolean;
  type?: 'BUSINESS' | 'PERSONAL';
  customerId?: number | string;
}
/**
 * Obtains a list of products by customer_id
 */
const useProductsByCustomer = ({
  allowRequest = true,
  type,
  customerId: customerIdParam,
}: UseProductsByCustomerParams = {}) => {
  const { customerId: customerIdFromContext } = useCustomerId();
  const customerId = customerIdParam !== undefined ? customerIdParam : customerIdFromContext;
  let URL = `/partner/products/customer/${customerId}`;
  if (type) {
    URL += `?type=${type}`;
  }
  const { data, isLoading, error } = useSWR(() => (allowRequest && customerId ? URL : false), {
    revalidateOnFocus: false,
  });
  return { data, isLoading, error };
};

export default useProductsByCustomer;
